import { SwapQualityIssueListType } from '../../enums/index';

export const swapQualityIssueListTypeMap = [
    { type: SwapQualityIssueListType.All, url: 'all', name: 'All' },
    { type: SwapQualityIssueListType.PendingResponse, url: 'pending-response', name: 'Pending Response' },
    { type: SwapQualityIssueListType.IssueReportedIncomplete, url: 'issue-reported-incomplete', name: 'Issue Reported - Incomplete' },
    { type: SwapQualityIssueListType.IssueReportedComplete, url: 'issue-reported-complete', name: 'Issue Reported - Complete' },
    { type: SwapQualityIssueListType.NoIssueReported, url: 'no-issue-reported', name: 'No Issue Reported' }
]